import { Record } from "immutable";

const AdminRecord = Record({
  id: null,
  adminKey: "",
  adminName: "",
  mail: "",
  invalidFlg: false,
  invalidReason: "",
  lockVersion: 0
});

class Admin extends AdminRecord {
  isNew() {
    return this.id === null;
  }

  isInvalid() {
    return this.invalidFlg;
  }

  validation() {
    const messages = [];

    if (this.adminKey === "") {
      messages.push("管理者IDを入力してください。");
    }
    if (this.adminName === "") {
      messages.push("管理者名を入力してください。");
    }
    if (this.mail === "") {
      messages.push("メールアドレスを入力してください。");
    }

    return messages;
  }
}

export default Admin;



// WEBPACK FOOTER //
// ./src/models/Admin.js